// extracted by mini-css-extract-plugin
export var askAiIcon = "_ma-j";
export var category = "_ma-9";
export var categoryHeader = "_ma-e";
export var container = "_ma-0";
export var group = "_ma-a";
export var groupItems = "_ma-f";
export var groupSeparator = "_ma-k";
export var loading = "_ma-1";
export var noResults = "_ma-3";
export var placeholder = "_ma-2";
export var resultContent = "_ma-5";
export var resultIcon = "_ma-c";
export var resultItem = "_ma-g";
export var resultMeta = "_ma-8";
export var resultSubtitle = "_ma-7";
export var resultSuffix = "_ma-i";
export var resultTitle = "_ma-6";
export var resultsList = "_ma-4";
export var searchGroup = "_ma-d";
export var selected = "_ma-h";
export var subgroup = "_ma-b";